module.exports = __webpack_public_path__ + "img/img (47).242c8070.jpg";